import { NetworkStatus as FoundationNetworkStatus } from '@mail-core/foundation';
import { IS_VKT_WEBVIEW } from 'reactApp/appHelpers/configHelpers';

const vktNetworkStatus = new FoundationNetworkStatus({
    forcedState: 'online',
});

if (IS_VKT_WEBVIEW) {
    import('reactApp/modules/vkTeam/vkTeam.module').then((module) => {
        module.vkTeamsBridge.subscribe('NetworkStatus', ({ status }) => {
            const isOnline = status === 'HIGH_QUALITY';

            vktNetworkStatus.setForcedState(isOnline ? 'online' : 'offline');
        });
    });
}

export const networkStatus = new FoundationNetworkStatus({
    stateSource: IS_VKT_WEBVIEW ? vktNetworkStatus : navigator,
    eventSource: IS_VKT_WEBVIEW ? vktNetworkStatus : window,
});
